module.exports = __webpack_public_path__ + "img/sl.780f1ed6.svg";